import { defineMessages } from 'react-intl';

export default defineMessages({
  admissionsInformation: {
    id: 'hubs.transfer.admissions-information.title',
    defaultMessage: 'Admissions Information',
  },
  transferApplicationsRequirements: {
    id: 'hubs.transfer.admissions-information.application-requirements.title',
    defaultMessage: 'Transfer Application Requirements',
  },
  contactInformation: {
    id: 'hubs.transfer.admissions-information.contact-information.title',
    defaultMessage: 'Admissions Contact Information',
  },
  applicationDeadlines: {
    id: 'hubs.transfer.admissions-information.application-deadlines.title',
    defaultMessage: 'Application Deadlines',
  },
  minHomeCredits: {
    id: 'hubs.transfer.admissions-information.min-credits.text',
    defaultMessage: `Transfer students must complete {credits} credits at the college to earn a bachelor's degree.`,
  },
  applicationSubmissionOptions: {
    id: 'hubs.transfer.admissions-information.application-options.title',
    defaultMessage: 'Application Submission Options',
  },
  required: {
    id: 'hubs.required',
    defaultMessage: 'Required',
  },
  phone: {
    id: 'hubs.phone',
    defaultMessage: 'Phone',
  },
  email: {
    id: 'hubs.email',
    defaultMessage: 'E-mail',
  },
});
